import React from "react";
import Sdata from "./Sdata";
import Card from "./Cards";

const Moviesb = ()=>{
    return(
        <Card
              key={Sdata[3].id}
              imgsrc={Sdata[3].imgsrc}
              title={Sdata[3].title}
              text={Sdata[3].text}
              link={Sdata[3].link} />
    )
}
export default Moviesb;